import { render, staticRenderFns } from "./VocabularyWordsRus.vue?vue&type=template&id=b83936c2&lang=pug&"
import script from "./VocabularyWordsRus.vue?vue&type=script&lang=js&"
export * from "./VocabularyWordsRus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports